<template>
  <div id="app">
    <!-- <div v-if="$route.meta.title!='国弘电力-首页'"> -->
      <Header></Header>
    <!-- </div> -->
    <router-view />
    <Footer></Footer>
    <GoTop></GoTop>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue